import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const iconButtonDefaultVariants = {
  "appearance": "default",
  "size": "default"
}
const iconButtonCompoundVariants = []

const iconButtonSlotNames = [
  [
    "container",
    "iconButton__container"
  ],
  [
    "icon",
    "iconButton__icon"
  ]
]
const iconButtonSlotFns = /* @__PURE__ */ iconButtonSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, iconButtonDefaultVariants, getSlotCompoundVariant(iconButtonCompoundVariants, slotName))])

const iconButtonFn = memo((props = {}) => {
  return Object.fromEntries(iconButtonSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const iconButtonVariantKeys = [
  "appearance",
  "size"
]
const getVariantProps = (variants) => ({ ...iconButtonDefaultVariants, ...compact(variants) })

export const iconButton = /* @__PURE__ */ Object.assign(iconButtonFn, {
  __recipe__: false,
  __name__: 'iconButton',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: iconButtonVariantKeys,
  variantMap: {
  "appearance": [
    "default",
    "primary",
    "subtle",
    "hollow"
  ],
  "size": [
    "default",
    "large",
    "small"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, iconButtonVariantKeys)
  },
  getVariantProps
})